export default __webpack_public_path__ + "static/media/ofertIconRed.63850780.svg";